import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import './UserInfoDisplay.scss';

/**
 * 用户信息展示组件
 * @param {Object} props
 * @param {Object} props.user - 用户信息对象
 */
const UserInfoDisplay = ({ user }) => {
  const { t } = useI18n();
  if (!user) return null;

  // Format registration date
  const formatDate = (dateString) => {
    if (!dateString) return t('personalCenter.userInfo.unknown');
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (error) {
      return t('personalCenter.userInfo.unknown');
    }
  };

  // Get registration method display text
  const getProviderText = (provider) => {
    switch (provider?.toLowerCase()) {
      case 'google':
        return t('personalCenter.userInfo.googleAccount');
      case 'email':
        return t('personalCenter.userInfo.emailRegistration');
      default:
        return t('personalCenter.userInfo.unknownMethod');
    }
  };

  // Get verification status display
  const getVerificationBadge = (isVerified) => {
    return (
      <span className={`info-badge ${isVerified ? 'verified' : 'unverified'}`}>
        {isVerified ? t('personalCenter.userInfo.verified') : t('personalCenter.userInfo.unverified')}
      </span>
    );
  };

  const infoItems = [
    {
      label: t('personalCenter.userInfo.emailAddress'),
      value: user.email,
      badge: getVerificationBadge(user.emailVerified)
    },
    {
      label: t('personalCenter.userInfo.registrationMethod'),
      value: getProviderText(user.authProvider || user.provider)
    },
    {
      label: t('personalCenter.userInfo.registrationDate'),
      value: formatDate(user.createdAt)
    }
  ];

  return (
    <div className="user-info-display">
      {infoItems.map((item, index) => (
        <div key={index} className="info-item">
          <label className="info-label">{item.label}</label>
          <div className="info-value">
            <span className="info-text">{item.value}</span>
            {item.badge}
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserInfoDisplay;